<template>
  <form @submit.prevent="submit">
    <vue-form-generator :schema="schema" :model="model" :options="{ validationAfterLoad: true, validationAfterChanged: true }" />
    <b-button v-if="schema.fields.length > 0"
              type="submit"
              variant="primary"
              block>{{ $t('actions.login') }}</b-button>
    <div v-else class="text-center">
      <i class="ti ti-2x ti-spin ti-refresh"/>
    </div>
  </form>
</template>

<script>
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';

  export default {
    name: 'LoginPage',
    components: {
      'vue-form-generator': VueFormGenerator.component,
    },
    props: {
      uri: {
        type: String,
        default: 'public/login/',
      },
      successRoute: {
        type: [Object, Function],
        default() {
          return { name: 'dashboard' };
        },
      },
      refModal: {
        type: String,
        default: null,
      },
      closeModal: {
        type: Boolean,
        default: false,
      },
      loadOnMount: {
        type: Boolean,
        default: true,
      },
      defaultModelValues: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        model: {
          rememberMe: true,
        },
        schema: {
          fields: [],
        },
      };
    },
    mounted() {
      if (this.loadOnMount) {
        this.load();
      }

      if (!this.loadOnMount && this.refModal !== null) {
        this.$bus.$on(`t-event.t-modal.${this.refModal}.opened`, this.load);
      }
    },
    methods: {
      async load() {
        const modelTemp = this.defaultModelValues !== null
          ? this.defaultModelValues
          : this.model;
        this.$set(this, 'model', modelTemp);

        if (this.$store.state.oauth) {
          this.forward();
        } else {
          await this.$ajax.get(this.uri)
            .then((data) => {
              _.each(data, (field) => {
                if (field.model === 'password') {
                  field.hint = '';
                }
              });

              this.$set(this.schema, 'fields', this._.form(this.$t, data));
              this.$bus.$emit('t-event.load-form.login.success');
            });
        }
      },
      goSuccessRoute() {
        if (typeof this.successRoute === 'function') {
          return this.successRoute();
        }
        return this.successRoute;
      },
      async submit() {
        await this.$ajax.login(this.model)
          .then(() => {
            this.$notify({
              title: this.$t('flashes.login.title'),
              text: this.$t('flashes.login.success'),
              type: 'success',
            });
            this.forward();
          })
          .catch((err) => {
            if (err.response) {
              this.$notify({
                title: this.$t('flashes.login.title'),
                text: this.$t(`flashes.login.${err.response.data.error}`),
                type: 'error',
              });
            }
          });
      },
      forward() {
        if (this.closeModal) {
          this.$bus.$emit(`t-event.t-modal.${this.refModal}.close`);
        }
        // TODO remove new-submit event.
        this.$bus.$emit('t-event.new-submit.login.success');
        this.$bus.$emit('t-event.login.success');
        this.$router.push(this.goSuccessRoute());
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// node_modules/@triotech/vue-core/src/components/authentification/AjaxLogin.vue